"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryRowList = SummaryRowList;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/SummaryRowList/index.tsx
// Figma: SummaryRow を積んだガラス面カード。
// LotteryDetail / Confirmation の「利用手数料」「お支払い金額」で使う。
//
// 1 行 = [ラベル (neutral.secondary)] … [値 (neutral.primary、右寄せ)]
// emphasized な行 (合計) はラベル・値ともに W6 + 16px にする。
//
// 色・影は theme.palette.v2 (useV2Palette) から取得する。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
var PropertyBlock_1 = require("../PropertyBlock");
function SummaryRowList(_a) {
    var rows = _a.rows;
    var p = (0, theme_1.useV2Palette)();
    return ((0, jsx_runtime_1.jsx)(PropertyBlock_1.PropertyBlock, { children: rows.map(function (row, i) {
            var isLast = i === rows.length - 1;
            var textStyle = row.emphasized
                ? tokens_1.textStyles.subsectionTitle
                : tokens_1.textStyles.body;
            var rowLineHeight = row.emphasized ? tokens_1.lineHeight.md : tokens_1.lineHeight.sm;
            return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", spacing: "".concat(tokens_1.spacing.sm, "px"), sx: {
                    boxSizing: 'border-box',
                    width: '100%',
                    px: "".concat(tokens_1.spacing.md, "px"),
                    py: "".concat(tokens_1.spacing.sm + tokens_1.spacing.xs, "px"),
                    borderBottom: isLast
                        ? 'none'
                        : "1px solid ".concat(p.border.neutral.default),
                }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign({ flex: '1 1 0%', minWidth: 0 }, textStyle), { lineHeight: "".concat(rowLineHeight, "px"), color: row.emphasized
                                ? p.foreground.neutral.primary
                                : p.foreground.neutral.secondary }), children: row.label }), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign({ flexShrink: 0 }, textStyle), { lineHeight: "".concat(rowLineHeight, "px"), color: p.foreground.neutral.primary, textAlign: 'right' }), children: row.value })] }, i));
        }) }));
}
